import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Embryo } from '@/rtk-query.gql';

import { EditEmbryoForm } from '../edit-embryo-form';
import { EditEmbryoFormValues } from '../edit-embryo-form/schema';

type EmbryoData = Embryo;

type EditEmbryoDialogProps = {
  visible: boolean;
  onHide: () => void;
  onSave: (data: EditEmbryoFormValues) => void;
  embryo?: EmbryoData;
  readOnly?: boolean;
  readOnlyReason?: string;
};

export const EditEmbryoDialog = ({
  visible,
  onHide,
  onSave,
  embryo,
  readOnly = false,
  readOnlyReason,
}: EditEmbryoDialogProps) => {
  const { t } = useTranslation();
  const handleSubmit = (values: EditEmbryoFormValues) => {
    onSave(values);
    onHide();
  };

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) onHide();
    },
    [onHide],
  );

  return (
    <Dialog open={visible} onOpenChange={handleOpenChange}>
      <DialogContent className="md:max-w-[min(1000px,95vw)]">
        <DialogHeader>
          <DialogTitle>
            {readOnly ? t('embryo.viewEmbryo') : t('embryo.editEmbryo')}
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <EditEmbryoForm
            visible={visible}
            onCancel={onHide}
            onSubmit={handleSubmit}
            embryo={embryo}
            readOnly={readOnly}
            readOnlyReason={readOnlyReason}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
